import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import "./Blog.css";
// import blogbanner from "../../images/blog-new.png";
import BlogSideBar from '../BlogSideBar/BlogSideBar';
import { END_URL, IMG_URL } from "../../config.js";
import { Link, useSearchParams } from "react-router-dom";
import { useParams } from "react-router-dom";
import { slugify } from '../../utils/slugify';
import blogbanner from "../../images/blog-slider-img.png";
import loadimg from "../../images/loader_wish.gif";
import { Helmet } from 'react-helmet';
import gg from "../../images/pp-logo.gif";

const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

const getTextPreview = (htmlString, maxChars = 95) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString || "";
  const text = tempDiv.textContent || tempDiv.innerText || "";
  return text.length > maxChars ? text.slice(0, maxChars) + "..." : text;
};



function Blog({token,userdetail,onLoginChange}) {

   const [blog, setblog] = useState([]);
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedTopicId, setSelectedTopicId] = useState(null);

  const [selectedTopicAdd, setselectedTopicAdd] = useState(null);

  const [selectedTopicLink, setselectedTopicLink] = useState(null);

  const { topicname: topicNameFromURL } = useParams();
  const [bannerLoaded, setBannerLoaded] = useState(false);

  const { topicname: topicSlugFromURL } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 12;
  const blogListRef = useRef(null);

  const [seo, setSeo] = useState({});
  const [bannerImage, setBannerImage] = useState(null);
  const [bannerLoading, setBannerLoading] = useState(true);

  const [TestLink,setTestLink] = useState(null);

   const [TestLink1,setTestLink1] = useState(null);

  const topicRefs = useRef({});

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        setLoading(true);

        const response = await axios.get(`${END_URL}/blog`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params: {
              topic: topicSlugFromURL,
            },
          });
        const fetchedTopics = response.data.topics || [];
        setTopics(fetchedTopics);

        const seoDate = response.data.seo_page; 

        setSeo(seoDate);

        setblog(response.data.blog || []);

        setTestLink(response?.data?.blog_adver_link?.slug);

        setTestLink1(response?.data?.topic_link?.slug);

        if (topicNameFromURL) {

          const matchedTopic = fetchedTopics.find(
            (topic) => slugify(topic.topicname) === topicSlugFromURL
          );

          if (matchedTopic) {
            setSelectedTopicId(matchedTopic.id);

            setselectedTopicAdd(matchedTopic.topic_adver);
            
            setselectedTopicLink(matchedTopic.topic_link);
            
          } else {
            setSelectedTopicId(null); 

            setselectedTopicAdd(null);

            setselectedTopicLink(null);

          }

        } else {
          setSelectedTopicId(null); 

          setselectedTopicAdd(null);

          setselectedTopicLink(null);
        }

      } catch (err) {
        console.error(err);
        setError('Error fetching blogs');
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, [topicNameFromURL]);

  // useEffect(() => {
  //   const fetchBanner = async () => {
  //     try {
  //       setBannerLoading(true);
  //       const response = await axios.get(`${END_URL}/blog_banner`);
  //       setBannerImage(response.data.blog_banner?.blog_banner || null);
  //     } catch (error) {
  //       console.error("Error fetching blog banner:", error);
  //       setBannerImage(null);
  //     } finally {
  //       setBannerLoading(false);
  //     }
  //   };

  //   fetchBanner();
  // }, []);



  const latestBlogs = topics
    .flatMap(topic => topic.blog || [])
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 3);



  const topicsToRender = selectedTopicId
    ? topics.filter(topic => topic.id === selectedTopicId)
    : topics;

  const latestBlogIds = latestBlogs.map(blog => blog.id);

  const allBlogs = topics
    .flatMap(topic => topic.blog || [])
    .filter(blog => !latestBlogIds.includes(blog.id)) 
    .sort((a, b) => new Date(b.date) - new Date(a.date));


  const filteredBlogs = selectedTopicId
    ? topics
      .find(topic => topic.id === selectedTopicId)
      ?.blog
      .filter(blog => !latestBlogIds.includes(blog.id))
      ?.sort((a, b) => new Date(b.date) - new Date(a.date)) || []
    : allBlogs;



  const totalPages = Math.ceil(filteredBlogs.length / blogsPerPage);

  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = filteredBlogs.slice(indexOfFirstBlog, indexOfLastBlog);



  useEffect(() => {
    setCurrentPage(1);
  }, [selectedTopicId]);

if (loading) {
  return (
    <div
  className="loadingDiv"
    >
      <img
        src={gg}  
        alt="Loading..."
       
      />
    </div>
  );
}

  return (
    <>
     <Helmet>
    
            <title>{seo?.meta_title || 'PersonalityTest - Discover Your True Archetype | Personality Peek'}</title>

            <meta name="description" content={seo?.meta_description || 'Take the Personality Test at Personality Peek. Discover your true archetype, unlock insights and start your self-discovery journey.'} />

            <meta name="keywords" content={seo?.meta_keywords || 'personality assessment test , personality test'} />
            
            {seo?.og_title && <meta property="og:title" content={seo.og_title} />}
            {seo?.og_description && <meta property="og:description" content={seo.og_description} />}
            {seo?.og_image && <meta property="og:image" content={`${IMG_URL}/d0/${seo.og_image}`} />}
            {seo?.og_url && <meta property="og:url" content={seo.og_url} />}
            {seo?.og_type && <meta property="og:type" content={seo.og_type} />}

            {seo?.twitter_title && <meta name="twitter:title" content={seo.twitter_title} />}
            {seo?.twitter_description && <meta name="twitter:description" content={seo.twitter_description} />}
            {seo?.twitter_image && <meta name="twitter:image" content={`${IMG_URL}/d0/${seo.twitter_image}`} />}
            {seo?.twitter_card && <meta name="twitter:card" content={seo.twitter_card} />}

            {seo?.og_url && <link rel="canonical" href={seo.og_url} />}

            {!seo?.og_title && <meta property="og:title" content="PersonalityTest - Discover Your True Archetype | Personality Peek" />}
            {!seo?.og_description && <meta property="og:description" content="Take the Personality Test at Personality Peek. Discover your true archetype, unlock insights and start your self-discovery journey." />}
            {!seo?.og_type && <meta property="og:type" content="website" />}
            {!seo?.twitter_card && <meta name="twitter:card" content="summary_large_image" />}

    </Helmet>


    <div className="blog-cont">

      <div className="blog-banner">
        <div className="container-fluid">


          <div className="row blog-banner-row">
            <div className="col-12 col-sm-12 col-md-12">

              <img
                  src={`${IMG_URL}/d0/${blog.blog_banner}`}

                  alt="Blog Banner"

                />    
              <div  dangerouslySetInnerHTML={{ __html:  blog?.blog_banner_content }} />
               
            </div>
          </div>
     
        </div>
      </div>


      <div className="blog-single-Div">

        <div className="container">

          <div className="row gy-4">

            {/* <h3>Latest Articles</h3> */}
{!loading && <h3>Latest Articles</h3>}


            {!loading && !error && latestBlogs.map(blog => (
              
              <div className="col-12 col-sm-6 col-md-4" key={blog.id}>
                <Link
                  to={`/blog/detail/${slugify(blog.title)}`}
                  className="blog-card-link"
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <div className="blog-single">
                    <img src={`${IMG_URL}/d0/${blog.image}`} alt={blog.title} />
                    <p>{blog.title}</p>
                    <div>
                      <div>  <span>Author : {blog.name}</span>
                        <span>{formatDate(blog.date)}</span></div>
                      <p className="blog-preview">{getTextPreview(blog.content, 95)}</p>
                    </div>

                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>


      <div className="blog-cardsDivs">
        <div className="container">
          <div className="row blog-card-row">
            <BlogSideBar
              topics={topics}
              selectedTopicId={selectedTopicId}
              blog_adver={blog?.blog_advertisment_image}
              blog_adver_link={blog?.blog_adver_link}
              token={token}
              userdetail={userdetail}
              onLoginChange={onLoginChange}
              TestLink={TestLink}
              selectedTopicAdd={selectedTopicAdd}
              selectedTopicLink={selectedTopicLink}
              TestLink1={TestLink1}
            />
            <div className="col-12 col-sm-12 col-md-8">
              {selectedTopicId && (
                <h4>
                  {topics.find(topic => topic.id === selectedTopicId)?.topicname}
                </h4>
              )}

              <div
                className="row gy-4 blog-ind-card"
                ref={blogListRef}
                tabIndex={-1} // Makes it focusable for accessibility
              >
{/*       
              {loading && (
                [...Array(3)].map((_, index) => (
                  <div className="col-12 col-sm-6 col-md-4">
                    <div className="blog-card-box skeleton3">
                      <div className="skeleton3-image"></div>
                      <div className="skeleton3-title"></div>
                      <div className="skeleton3-meta"></div>
                      <div className="skeleton3-text"></div>
                    </div>
                  </div>
                ))
              )} */}

                {!loading && !error && currentBlogs.map(blog => (
                  <div className="col-12 col-sm-6 col-md-4" key={blog.id}>
                    <Link
                      to={`/blog/detail/${slugify(blog.title)}`}
                      className="blog-card-link"
                      style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                      <div className="blog-card-box">
                        <img src={`${IMG_URL}/d0/${blog.image}`} alt={blog.title} />
                        <p>{blog.title}</p>
                        <div>
                          <div>
                            <span>Author: {blog.name}</span>
                            <span>{formatDate(blog.date)}</span>
                          </div>
                          <p className="blog-preview">{getTextPreview(blog.content, 100)}</p>
                        </div>
                      </div>
                    </Link>



                  </div>
                ))}

                <div className="col-12 col-sm-12 col-md-12 blog-pagination">

                  {totalPages > 1 && (
                    <div className="pagination">
                      <button
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>
                      {pageNumbers.map(number => (
                        <button
                          key={number}
                          onClick={() => setCurrentPage(number)}
                          disabled={currentPage === number}
                          className={currentPage === number ? 'active' : ''}
                        >
                          {number}
                        </button>
                      ))}
                      <button
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </div>
                  )}


                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    </>
  );
}

export default Blog;
